<br>
  <div>
    <div>
      <h4>Zip Code Assignments</h4>
    </div>
  </div>
  <br>
    @if (zipCodes) {
      <div>
        <p-button label="Save All" (click)="saveAll()" severity="success" [disabled]="!canSave || saving"></p-button>
        @for (rm of rms; track rm) {
          <div>
            <app-zip-code-assignment-item [rm]="rm" [zipCodes]="zipCodes"></app-zip-code-assignment-item>
          </div>
        }
      </div>
    }